import { z } from "zod";

const allowedName = /^[A-Za-z][A-Za-z '\u2018\u2019\-]{0,29}$/;
const allowedMessage = /^[A-Za-z0-9][A-Za-z0-9 .,!?;:'\u2018\u2019\-()&]{0,199}$/;

const optionalEmail = z.preprocess(
  (value) => value === null || (typeof value === "string" && value.trim() === "") ? undefined : value,
  z.string().trim().email("Please enter a valid email address.").max(254, "Use 254 characters or fewer.").optional(),
);

export const submissionTextSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "Please enter your name.")
    .max(30, "Use 30 characters or fewer.")
    .regex(allowedName, "Use Latin letters, spaces, apostrophes or hyphens."),
  message: z
    .string()
    .trim()
    .min(1, "Please write a message.")
    .max(200, "Use 200 characters or fewer.")
    .regex(allowedMessage, "Use Latin letters, numbers and basic punctuation only."),
  email: optionalEmail,
});

export const MAX_PHOTO_BYTES = 8 * 1024 * 1024;
export const ACCEPTED_PHOTO_TYPES = new Set(["image/jpeg", "image/webp", "image/png"]);
